import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Types
import { Change } from '../../../../../../../types/Form';
import { Address } from '../../../../../../../types/Common';
import { HomeSearchAnswer } from './HomeInputComponent';
import { useBoolean, Flex, AddressInput } from '@wegroup/design-system';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import QuestionGroupActions from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupActions';
import AdvisoryFlowMainContainer from '../../../ui/advisory-flow/components/app-shell/AdvisoryFlowMainContainer';
import QuestionGroupAssistantQuestion from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupAssistantQuestion';
import useIsCaribbean from '../../../../../../common/src/hooks/useIsCaribbean';
import { useFlowsRouteParams } from '../../../../hooks/useFlowsRouteParams';
import { useFlowsSession } from '../../../../api/getFlowsSessionById';

interface Props {
  value?: HomeSearchAnswer;
  error?: string;
  question: FlowsQuestion;
  onChange: (arg0: Change) => void;
  nextSubView: (arg0: string) => void;
  previousSubView: () => void;
  setHomeInformation: (arg0: HomeSearchAnswer) => Promise<void>;
}

const HomeAddressInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  value,
  error,
  question,
  onChange,
  nextSubView,
  previousSubView,
  setHomeInformation,
}) => {
  const { t } = useTranslation();
  const isCaribbean = useIsCaribbean();
  const [loading, setLoading] = useBoolean();
  const [address, setAddress] = useState<Address>();
  const [localError, setLocalError] = useState();
  const { sessionId } = useFlowsRouteParams();
  const session = useFlowsSession(sessionId);

  const partyId = session?.data?.prospect?.id || '';

  const handleChange = (address?: Address) => {
    setAddress(address);
  };

  const handleOnContinue = async () => {
    if (
      address?.housenr == null ||
      !address?.street ||
      !address?.city ||
      (!address?.zipcode && !isCaribbean) ||
      !address.country_code
    )
      return setLocalError(t('Please fill in a valid address'));

    setLoading.on();
    await setHomeInformation({
      address: address,
      attic: undefined,
      cellar: undefined,
      _local: { self: address?.self },
    });
    setLoading.off();
    nextSubView('houseDetail');
  };

  const Question = () => (
    <QuestionGroupAssistantQuestion
      question={t('What’s the address you would like to insure?')}
      description={t(
        'Please enter your street name, number and city You can fill out more details later',
      )}
    />
  );

  return (
    <AdvisoryFlowMainContainer>
      <Question />
      <Flex
        maxW="700px"
        mx="auto"
        alignItems="flex-start"
        justifyContent="center"
        flexGrow={1}
        px="4"
        py="8"
        w="100%"
      >
        <AddressInput
          error={error || localError}
          value={address}
          onChange={handleChange}
          partyId={partyId}
        />
      </Flex>
      <QuestionGroupActions
        onBack={previousSubView}
        onContinue={handleOnContinue}
        isLoading={loading}
      />
    </AdvisoryFlowMainContainer>
  );
};

export default HomeAddressInputComponent;
